import { useState } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function Confirm({ open, onClose, title, text, yes = "Yes, do it", danger, onYes, pending, testId = "confirm" }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid={testId}>
        <AlertDialogHeader><AlertDialogTitle className="text-[#101C47]">{title}</AlertDialogTitle><AlertDialogDescription className="text-base">{text}</AlertDialogDescription></AlertDialogHeader>
        <AlertDialogFooter><AlertDialogCancel data-testid={`${testId}-no`}>No, go back</AlertDialogCancel><AlertDialogAction disabled={pending} onClick={(e) => { e.preventDefault(); onYes(); }} className={cn("text-white", danger ? "bg-[#F92626] hover:bg-[#E01C1C]" : "bg-[#101C47] hover:bg-[#1B2D6E]")} data-testid={`${testId}-yes`}>{pending ? "Working…" : yes}</AlertDialogAction></AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function AskText({ open, onClose, title, text, label, initial = "", placeholder, onSave, pending, testId = "ask-text" }) {
  const [v, setV] = useState(initial);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid={testId}>
        <DialogHeader><DialogTitle className="text-[#101C47]">{title}</DialogTitle>{text && <DialogDescription>{text}</DialogDescription>}</DialogHeader>
        <form className="space-y-3" onSubmit={(e) => { e.preventDefault(); if (v.trim().length >= 2) onSave(v.trim()); }}>
          <label className="block"><span className="tqi-eyebrow">{label}</span><Input autoFocus value={v} onChange={(e) => setV(e.target.value)} placeholder={placeholder} className="mt-1 h-12 text-lg" data-testid={`${testId}-input`} /></label>
          <div className="flex justify-end gap-2"><Button type="button" variant="outline" onClick={onClose}>Cancel</Button><Button type="submit" disabled={pending || v.trim().length < 2} className="bg-[#101C47] hover:bg-[#1B2D6E] text-white" data-testid={`${testId}-save`}>{pending ? "Saving…" : "Save"}</Button></div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
